import { createContext } from "react";
import { ProviderProps } from "../interfaces/common.interfaces";

export const UtilsContext = createContext({});

export const UtislProvider = ({ children }: ProviderProps) => {
  return <UtilsContext.Provider value={{}}>{children}</UtilsContext.Provider>;
};
